import { api } from './client';

export interface TripListItem {
  slug: string;
  header: string;
  subtitle?: string;
  dateBadge?: string;
  dateStart?: string;
  dateEnd?: string;
}

export function fetchTripList(signal?: AbortSignal): Promise<{ trips: TripListItem[] }> {
  return api.get('/trips/api/list', { signal });
}
